import { render, staticRenderFns } from "./UserAchievements.vue?vue&type=template&id=07d215ae&"
import script from "./UserAchievements.vue?vue&type=script&lang=js&"
export * from "./UserAchievements.vue?vue&type=script&lang=js&"
import style0 from "./UserAchievements.vue?vue&type=style&index=0&id=07d215ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports